module.exports = __webpack_public_path__ + "img/3dvalve_white.ac48653d.png";